import React, { PropTypes } from 'react'

import './SearchResults.scss'
import SearchResultItem from 'components/SearchResultItem'
import SearchNoResults from './components/SearchNoResults'
import SearchNoResultsSecondTimeUser from './components/SearchNoResultsSecondTimeUser'

const renderResults = ({results, searchProps, reserveAliada}) => {
  const list = results.map(
    (aliada, index) => (
      <SearchResultItem
        aliada={aliada}
        key={aliada.id}
        searchProps={searchProps}
        reserveAliada={reserveAliada}
        />
    )
  )
  return (
    <div>
      <h3>Encontramos { results.length } Aliada{ results.length !== 1 ? 's' : '' }</h3>

      <div className='SearchResults'>
        {list}
      </div>
    </div>
  )
}

const renderNoResults = ({ secondTimeUser = false, searchProps, status, configureSetup }) => {
  if (secondTimeUser) {
    return (
      <div className='SearchResults SearchResults--noResults'>
        <SearchNoResultsSecondTimeUser
          searchProps={searchProps}
          configureSetup={configureSetup}
          />
      </div>
    )
  } else {
    return (
      <div className='SearchResults SearchResults--noResults'>
        <SearchNoResults
          searchProps={searchProps}
          status={status}
        />
      </div>
    )
  }
}

const SearchResults = (props) => {
  return props.results.length === 0
            ? renderNoResults(props)
            : renderResults(props)
}
SearchResults.displayName = 'SearchResults'
SearchResults.propTypes = {
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  searchProps: PropTypes.shape({
    estimatedHours: PropTypes.number.isRequired,
    neighborhood: PropTypes.string.isRequired,
    coordinates: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired
    }).isRequired,
    skills: PropTypes.array,
    preferences: PropTypes.array,
    date: PropTypes.string,
    time: PropTypes.string,
    serviceTypeId: PropTypes.number.isRequired
  }).isRequired,
  reserveAliada: PropTypes.func.isRequired
}
SearchResults.defaultProps = {
  searchProps: {
    skills: [],
    preferences: []
  }
}

export default SearchResults



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/SearchResults.js